import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function toggleDisplayReducerFactory(rootProp, initialState) {
    return function toggleDisplayReducer(state = initialState, action) {
        const stateProp: string = action.stateProp;
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${GenericActions.DISPLAY_TOGGLED}`:
                return state.setIn([stateProp, "selectedIndex"], action.payload);
            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return state.set(stateProp, initialState.get(stateProp));
            default:
                return state;
        }
    };
}
